export class NoLatestProposalRecordFoundError extends Error {
}